import React, { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import api from "../../../services/api";
import styleButton from "../../../components/Button/Button.module.css";
import Loading from "../../../components/Loading";
import Board2 from "../../../components/Board";
import useWrapper from "../../../hooks/useWrapper";

export default function NewBudget() {
  const { setbreadcrumb, config, permissions } = useWrapper();

  const navigate = useNavigate();

  const [loadingPage, setLoadingPage] = useState(true);
  const [board, setboard] = useState([]);

  useEffect(() => {
    (async function () {
      let response;
      try {
        response = await api.get("steps?commercials.is_class=0&paginate=false", config);
      } catch (error) {
        error.response.status === 401 && navigate("/no-permission");
      }

      if (response) {
        let _board = response.data;
        _board = _board.map(__step => ({
          label: __step.name,
          description: __step.description,
          step_id: __step.id,
          data: __step.commercials.map(__group => {
            let _tasks = {
              planned: 0,
              confirmed: 0,
              late: 0,
            };
            // __group.calendars.forEach(__task => {
            //   if (new Date(__task.date_start) < new Date() && __task.all_day) {
            //     _tasks.late++;
            //   }
            //   else if (new Date(__task.date_end) < new Date() && !__task.all_day) {
            //     _tasks.late++;
            //   }
            //   else if (__task.status === "confirmed") {
            //     _tasks.confirmed++;
            //   }
            //   else if (__task.status === "foreseen") {
            //     _tasks.planned++;
            //   }
            // })
            return {
              id: __group.id,
              title: `${__group.course.title} ${__group.year}.${__group.period}`,
              institution: __group.institution.title,
              trainees: Number(__group.total_trainees),
              tasks: {
                planned: _tasks.planned,
                confirmed: _tasks.confirmed,
                late: _tasks.late,
              },
              has_budget: __group?.budgetColections?.length > 0,
              contract_number_legacy: __group?.contract_number_legacy || "",
            };
          }),
        }));
        setboard(_board);
        setLoadingPage(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount; `config` is a new object every WrapperProvider render and would cause repeated re-fetches
  }, [navigate]);

  useEffect(() => {
    setbreadcrumb([{ label: "Comercial", title: true }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      {!loadingPage ? (
        <Content>
          <Row className="justify-content-between mb-3">
            <Col>
              <h2 class="page-title">Negociações em andamento</h2>
            </Col>
            <Col sm={6} className="d-flex flex-row row-list">
              <div className="d-flex flex-grow-1"></div>
              {permissions?.commercial?.createModel && (
                <NavLink to="/business/templatebusiness" className={styleButton.button_clean}>
                  Modelos
                </NavLink>
              )}
              {permissions?.commercial?.create && (
                <NavLink to="/business/new" className={styleButton.button_ghost}>
                  <span>Nova Negociação</span>
                </NavLink>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Board2 board={board} setboard={setboard} />
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
